import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ListComponent } from './list/list.component';
import { HistoryComponent } from './history/history.component';
import { SharedModule } from '../shared/shared.module';
import { DetailComponent } from './detail/detail.component';
import { GroupsComponent } from '../people/groups/groups.component';
import { TextDetailComponent } from './text-detail/text-detail.component';
import { TextsComponent } from './texts/texts.component';
import { SentsDialogComponent } from './sents-dialog.component';
import { BasicLayoutComponent } from '../common/layouts/basicLayout.component';
import { AuthGuard, PrepareGuard } from '../core/core.module';
import { CampaignOverviewComponent } from './campaign-overview.component';
import { CampaignDetailComponent } from './campaign-detail.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'messages',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'drafts', pathMatch: 'full' },
                    {
                        path: 'drafts',
                        component: ListComponent,
                        data: { title: 'Messages - Drafts', mode: 'drafts' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'drafts/:id',
                        component: DetailComponent,
                        data: { title: 'Messages - Compose', mode: 'drafts' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'sent-items',
                        component: ListComponent,
                        data: { title: 'Messages - Sent', mode: 'sent' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'sent-items/:id',
                        component: DetailComponent,
                        data: { title: 'Messages - Sent', mode: 'sent' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'groups',
                        component: GroupsComponent,
                        data: { title: 'Messages-Group' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'texts',
                        component: TextsComponent,
                        data: { title: 'Messages-Texts' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'texts/:id',
                        component: TextDetailComponent,
                        data: {
                            title: 'Messages-Text Compose',
                            mode: 'drafts',
                        },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'campaigns',
                        component: CampaignOverviewComponent,
                        data: { title: 'Campaigns' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'campaigns/:id',
                        component: CampaignDetailComponent,
                        data: { title: 'Campaigns - Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
})
export class MessagesModule {}
